import { render, staticRenderFns } from "./CardListPost.vue?vue&type=template&id=6790ebaa&scoped=true&"
import script from "./CardListPost.vue?vue&type=script&lang=js&"
export * from "./CardListPost.vue?vue&type=script&lang=js&"
import style0 from "./CardListPost.vue?vue&type=style&index=0&id=6790ebaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790ebaa",
  null
  
)

export default component.exports